var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Ratings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-ratings",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7075",
    "data-name": "Rectangle 7075",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-star-svgrepo-com",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M0,0H20V20H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M10.667,11.833V13.5a5,5,0,0,0-5,5H4a6.667,6.667,0,0,1,6.667-6.667Zm0-.833a5,5,0,1,1,5-5A5,5,0,0,1,10.667,11Zm0-1.667A3.333,3.333,0,1,0,7.333,6,3.332,3.332,0,0,0,10.667,9.333Zm5,8.75-2.449,1.288.467-2.727L11.7,14.712l2.738-.4,1.224-2.481,1.225,2.481,2.738.4-1.981,1.932.467,2.727Z",
    transform: "translate(-0.667 -0.167)",
    fill: "#02466a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Ratings);
export default __webpack_public_path__ + "static/media/icon-24-ratings.93019e73e316b051c6e4d44bdbe0c07b.svg";
export { ForwardRef as ReactComponent };